import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.classList.add("transition", "duration-500", "ease-in-out", "opacity-0");

    setTimeout(() => {
      this.element.classList.remove("opacity-0");
    }, 100);

    setTimeout(this.hide.bind(this), 5000);
  }

  hide() {
    const height = this.element.getBoundingClientRect().height;
    const top = this.element.getBoundingClientRect().top;
    const shadowSize = 30;
    const newYPosition = height + top + shadowSize;
    this.element.style.transform = `translateY(${-newYPosition}px)`;
  }
}
